// Language-based route helpers. Home base paths: /ec (Spanish, default) and /en (English).
// Policy pages live under the language base.

export const LANGS = ["ec", "en"];
export const DEFAULT_LANG = "ec";

export const PAGE_SLUGS = {
  home: { ec: "", en: "" },
  privacy: { ec: "politica-de-privacidad", en: "privacy-policy" },
  cookies: { ec: "politica-de-cookies", en: "cookie-policy" },
  terms: { ec: "terminos-y-condiciones", en: "terms-and-conditions" },
};

export const pathFor = (page, lang) => {
  const l = LANGS.includes(lang) ? lang : DEFAULT_LANG;
  const slug = PAGE_SLUGS[page]?.[l] ?? "";
  return slug ? `/${l}/${slug}` : `/${l}`;
};

// Return the same page path but in the other language, so language switch keeps user on the same page.
export const switchLangPath = (currentPath, targetLang) => {
  const parts = currentPath.split("/").filter(Boolean); // e.g. ["ec","politica-de-privacidad"]
  const currentLang = parts[0];
  if (!LANGS.includes(currentLang)) return `/${targetLang}`;
  const currentSlug = parts.slice(1).join("/");
  if (!currentSlug) return `/${targetLang}`;
  // Find which page the current slug represents
  const pageKey = Object.keys(PAGE_SLUGS).find(
    (k) => PAGE_SLUGS[k][currentLang] === currentSlug,
  );
  if (!pageKey) return `/${targetLang}`;
  const targetSlug = PAGE_SLUGS[pageKey][targetLang];
  return targetSlug ? `/${targetLang}/${targetSlug}` : `/${targetLang}`;
};
